import { render, staticRenderFns } from "./DisputeAuditLogs.vue?vue&type=template&id=25dfd5b6&"
import script from "./DisputeAuditLogs.vue?vue&type=script&lang=js&"
export * from "./DisputeAuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./DisputeAuditLogs.vue?vue&type=style&index=0&id=25dfd5b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports